import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPutRequest,
  apiGetRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { kmMessages } from "src/constant/Messages";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const AttendanceEditForm = ({ enableGlobalLoader, disableGlobalLoader, displaySnackbar, setLogoutUser, ...rest }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [users, setUsers] = useState();

  let pageTitle = "Potwierdzenie urzestnictwa w imieniu uzytkownika";

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getCommitteeAttendanceUsers.path, true)
      .then((data) => {
        disableGlobalLoader();
        setUsers(data);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, []);

  const onSubmit = (userId,action) => {
    if (action){
      enableGlobalLoader();

      apiPutRequest(
        apiEndpoints.setCommitteeAttendanceConfirmationForUser.path,
        {
          structNodeId: entryId,
          userId: userId,
          action: action
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate(`/potwierdzeniaudzialu/${entryId}`);
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
   
    } else {
      displaySnackbar({
        isOpen: true,
        severity: "error",
        autoHideDuration: 5000,
        message: kmMessages.error.document.attendance_foruser_option,
      });
    }
  };
    

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form onSubmit={onSubmit} users={users} entryId={entryId} />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
    setLogoutUser: () => dispatch(actions.setLogoutUser())
});

export default connect(null, mapDispatchToProps)(AttendanceEditForm);
